module.exports = __webpack_public_path__ + "img/Dep.d7a83b2c.webp";